import React from 'react';
import InfoNoticeCard from './InfoNoticeCard';
import SuccessNoticeCard from './SuccessNoticeCard';
import ErrorNoticeCard from './ErrorNoticeCard';
import WarningNoticeCard from './WarningNoticeCard';
import CourseNoticeCard from './CourseNoticeCard';

// 定义通知类型
export type NotificationType = 'info' | 'success' | 'error' | 'warning' | 'course';

// 定义通知数据接口
export interface NotificationData {
  notification_id: string;
  title: string;
  content: string;
  type: string;
  timestamp?: string;
  metadata?: Record<string, any>;
}

// 通知组件映射
const notificationComponentMap = {
  info: InfoNoticeCard,
  success: SuccessNoticeCard,
  error: ErrorNoticeCard,
  warning: WarningNoticeCard,
  course: CourseNoticeCard,
};

// 通知映射器组件属性
interface NotificationMapperProps {
  notification: NotificationData;
  onClose?: (notificationId: string) => void;
}

// 通知映射器组件
const NotificationMapper: React.FC<NotificationMapperProps> = ({ 
  notification, 
  onClose 
}) => {
  // 获取通知类型，默认为info
  const notificationType = notification.type as NotificationType;
  const Component = notificationComponentMap[notificationType] || notificationComponentMap.info;
  
  // 格式化时间戳
  const formatTimestamp = (timestamp?: string) => {
    if (!timestamp) return 'just now';
    
    try {
      const date = new Date(timestamp);
      const now = new Date();
      const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
      
      if (diffInMinutes < 1) return 'just now';
      if (diffInMinutes < 60) return `${diffInMinutes} min ago`;
      if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)} hour ago`;
      return `${Math.floor(diffInMinutes / 1440)} day ago`;
    } catch {
      return 'just now';
    }
  };

  return (
    <div 
      onClick={() => onClose?.(notification.notification_id)}
      style={{ 
        margin: '10px 0',
        position: 'relative',
        zIndex: 1000
      }}
    >
      <Component
        title={notification.title}
        content={notification.content}
        timestamp={formatTimestamp(notification.timestamp)}
      />
    </div>
  );
};

export default NotificationMapper;

// 导出所有通知组件以便单独使用
export {
  InfoNoticeCard,
  SuccessNoticeCard,
  ErrorNoticeCard,
  WarningNoticeCard,
  CourseNoticeCard,
};